import { DirectiveOptions } from 'vue';

type ElementWithWillChangeHandler = HTMLElement & { 
  _willChangeActive: () => void; 
  _willChangeAuto: () => void 
};

export const willChange: DirectiveOptions = {
  bind(el: ElementWithWillChangeHandler, binding) {
    el._willChangeActive = function () {
      const label = el.getElementsByClassName("will-change");
      if (label.length > 0) {
        (label[0] as HTMLElement).style.willChange = binding.value;
        (label[0] as HTMLElement).classList.add("will-change-active");
      }
    };
    el._willChangeAuto = function () {
      const label = el.getElementsByClassName("will-change");
      if (label.length > 0) {
        (label[0] as HTMLElement).style.willChange = "auto";
        (label[0] as HTMLElement).classList.remove("will-change-active");
      }
    };
    el.addEventListener("mouseenter", el._willChangeActive);
    el.addEventListener("transitionend", el._willChangeAuto);
  },
  unbind(el: ElementWithWillChangeHandler) {
    el.removeEventListener("mouseenter", el._willChangeActive);
    el.removeEventListener("transitionend", el._willChangeAuto);
    el._willChangeActive = null;
    el._willChangeAuto = null;
  },
};